import type { FeatureLike } from "ol/Feature";
import type MapBrowserEvent from "ol/MapBrowserEvent";

export type OlFeatureClickDetail = {
    readonly features: readonly FeatureLike[];
    readonly mapBrowserEvent: MapBrowserEvent;
};

export class OlFeatureClickEvent extends Event {
    public readonly detail: OlFeatureClickDetail;

    public constructor(detail: OlFeatureClickDetail) {
        super("ol-feature-click", {
            bubbles: true,
            composed: true,
        });

        this.detail = detail;
    }
}
